const getters = {
  key: (state) => state.common.key,
  rocker: (state) => state.common.rocker,
  joystick: (state) => state.common.joystick,
  // token
  token: (state) => state.common.token,
  language: (state) => state.common.language,
};
export default getters;
